import Modal from 'components/Modal/Modal'
import React from 'react'
import CreateFindings from '../createDiagnosticFindings/createDiagnosticFindings';
import styles from "../report.module.scss";
import Close from "assets/icons/close.svg"

const AddFindingsModal = ({ isOpen, 
    isClose, setAddNewFindings, setFindings, edit }) => {
  return (
    <Modal isOpen={isOpen} isClose={isClose} width={900} height={700}>
        <div className={styles.addFindings}>
            <div className={styles.addFindings__close} onClick={isClose}>
                <img src={Close} alt="close" />
            </div>
            <div className={styles.addFindings__header}>
                <h5>Add New Findings</h5>
            </div>
            <CreateFindings
            setAddNewFindings={setAddNewFindings}
            setFindings={setFindings}
            edit={edit}
            isClose={isClose}
            />
        </div>
    </Modal>
  )
}

export default AddFindingsModal